import { __rest } from "tslib";
import React from 'react';
import VeltSubtitlesEmbedModeWireframe from './VeltSubtitlesEmbedModeWireframe/VeltSubtitlesEmbedModeWireframe';
import VeltSubtitlesFloatingModeWireframe from './VeltSubtitlesFloatingModeWireframe/VeltSubtitlesFloatingModeWireframe';
import { transformWireframeProps } from '../../utils/propUtils';
var VeltSubtitlesWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement(React.Fragment, null, children));
};
VeltSubtitlesWireframe.EmbedMode = VeltSubtitlesEmbedModeWireframe;
VeltSubtitlesWireframe.FloatingMode = VeltSubtitlesFloatingModeWireframe;
export default VeltSubtitlesWireframe;
